import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpUrlEncodingCodec, } from '@angular/common/http';
import { CacheService } from '../../cache.service';
import { environment } from '../../../environments/environment';
import { AppService } from '../../app.service';
import { Token } from '../../app.model';
@Injectable({
  providedIn: 'root'
})
export class NotificationService {

  private headers = new HttpHeaders({
    'Content-Type': 'application/json'
  });
  private vmUrl = environment.vmUrl;

  constructor(private appService: AppService,
    private cacheService: CacheService,
    private http: HttpClient) {}

  private setAuthHeader(): HttpHeaders {
    return this.headers.set(
      'Authorization',
      'Bearer ' + this.cacheService.getObject < Token > ('saras_auth_key').token
    );

  }

  public async deleteNotification(notificationId: number) {
    await this.appService.getRefreshToken();

    const headers = this.setAuthHeader();

    return this.http
      .delete(`${this.vmUrl}panel/panel-notification/${notificationId}`, {
        headers
      }).toPromise();
  }

  public async deleteBulkNotifications(notificationIds: number[]) {
    await this.appService.getRefreshToken();

    const headers = this.setAuthHeader();

    return this.http
      .delete(`${this.vmUrl}panel/panel-notifications`, {
        headers,
        params: new HttpParams().set('ids', notificationIds.join(','))
      }).toPromise();
  }
}
